"use client";

import { useEffect, useRef } from "react";
import { captureException } from "@sentry/nextjs";
import { Dialog } from "@ariakit/react";
import { usePathname, useRouter } from "next/navigation";
import cn from "classnames";

import type { MouseEvent } from "react";

import styles from "../../../../../components/ArticleModal/ArticleModal.module.scss";
import { ErrorPage } from "../../../../../components/ErrorPage/ErrorPage";
import { useArticleModalStore } from "../../../../../store/useArticleModalStore";
import { Button } from "../../../../../components/Button/Button";

export default function Error({ error }: { error: Error }) {
  const pathName = usePathname();
  const router = useRouter();
  const modalRef = useRef<HTMLDivElement>(null);
  const { modalReferer, closeModal } = useArticleModalStore();
  console.log("Error", error);
  const dismissModal = () => {
    closeModal();
    router.push(modalReferer || "/", { scroll: false });
  };

  const onOutsideClick = (event: MouseEvent<HTMLElement>) => {
    if (modalRef.current?.isSameNode(event.target as Node)) {
      dismissModal();
    }
  };

  useEffect(() => {
    captureException("Article-Modal crashed" + error, {
      extra: { modal: "true", pathName: pathName },
    });
  }, [error, pathName]);

  return (
    <Dialog
      portal={false}
      open
      className={styles.articleModal}
      preventBodyScroll={true}
      backdrop={<div className={styles.backdrop} />}
    >
      <div
        className={styles.articleModalContent}
        onClick={onOutsideClick}
        ref={modalRef}
      >
        <div className={styles.articleModalContentMain}>
          <section className={styles.inlineArticle}>
            <header className={styles.inlineArticleHeader}>
              <div
                className={cn([
                  styles.inlineArticleHeaderTools,
                  styles.inlineArticleHeaderToolsRight,
                ])}
              >
                <Button
                  size="tiny"
                  icon="close"
                  variant="icon"
                  onClick={dismissModal}
                  slug="close-article-modal"
                  hiddenText="Stäng"
                />
              </div>
            </header>
            <div
              className={cn([styles.inlineArticleContent, styles.fullHeight])}
            >
              <ErrorPage
                heading="Oj! Något har gått fel."
                paragraph="Vi ber om ursäkt och försöker åtgärda problemet så snart vi kan, håll
    ut! Har du frågor eller funderingar? Mejla oss på info@omni.se"
              />
            </div>
          </section>
        </div>
      </div>
    </Dialog>
  );
}
